module.exports = __webpack_public_path__ + "static/media/dot.63b1ec5f.svg";